module.exports = __webpack_public_path__ + "img/logomark.441bab05.svg";